import { UserRole } from "tm-shared/types";

export const ROLE_CHILDREN_MAP: Partial<Record<UserRole, UserRole>> = {
    [UserRole.Sv]: UserRole.Ta,
    [UserRole.Svm]: UserRole.Md,
    [UserRole.Kam]: UserRole.Kam,
};

export const ROLE_PARENT_MAP: Partial<Record<UserRole, UserRole>> = {
    [UserRole.Ta]: UserRole.Sv,
    [UserRole.Md]: UserRole.Svm,
    [UserRole.Kam]: UserRole.Kam,
};
